import { Button, styled } from '@mui/material';
import { buttonClasses } from '@mui/material/Button';

// Acciones de borrado de Disponibilidad ("Eliminar todo" / "Eliminar semana"): mismo CTA
// SÓLIDO que "Repetir disponibilidad" (mode-aware vía vars CSS → negro/blanco según modo,
// siempre legible). Al hacer HOVER vira a ROJO con texto blanco, señalando que es una
// acción destructiva.
const StyledAvailabilityActionButton = styled(Button)(() => ({
  backgroundColor: 'var(--otx-cta-bg)',
  border: '1px solid transparent',
  borderRadius: 10,
  color: 'var(--otx-cta-text)',
  flexShrink: 0,
  fontWeight: 800,
  padding: '7px 16px',
  textTransform: 'none',
  transition:
    'background-color 200ms cubic-bezier(0.32, 0.72, 0, 1), color 200ms cubic-bezier(0.32, 0.72, 0, 1), transform 200ms cubic-bezier(0.32, 0.72, 0, 1)',
  '& span': {
    color: 'inherit'
  },
  '&:hover': {
    backgroundColor: '#B21616',
    color: '#FFFFFF'
  },
  '&:active': {
    transform: 'scale(0.98)'
  },
  [`&.${buttonClasses.disabled}`]: {
    backgroundColor: 'var(--otx-btn-disabled-bg)',
    color: 'var(--otx-btn-disabled-text)'
  }
}));

export default StyledAvailabilityActionButton;
